// Why a debt can be left out of DTI. Fannie Mae Selling Guide (2026-09-02):
// B3-6-05 Monthly Debt Obligations (p.534-536) and B3-6-07 Debts Paid Off At or
// Prior to Closing (p.542). Stored with the calculator settings only.
export const EXCLUSION_REASONS = [
    { code: "paidByOther", label: "Paid by someone else", doc: "12 months of the payer's canceled checks or bank statements with no late payments (B3-6-05)" },
    { code: "tenOrFewer", label: "10 or fewer payments left", doc: "Installment debt only; lease payments always count (B3-6-05)" },
    { code: "businessDebt", label: "Business debt paid by the business", doc: "12 months of company checks, and the payment is in the business cash-flow analysis (B3-6-05)" },
    { code: "courtAssigned", label: "Assigned to someone else by court order", doc: "Divorce decree or separation agreement (B3-6-05)" },
    { code: "notBorrowers", label: "Not the borrower's account", doc: "Documentation that the account belongs to someone else (B3-6-05, non-applicant accounts)" },
    { code: "paidAtClosing", label: "Paid off at or before closing", doc: "Payoff on the closing disclosure (B3-6-07)" },
    { code: "other", label: "Other", doc: "Explain in the note" },
]

export const exclusionReason = (code) => EXCLUSION_REASONS.find((reason) => reason.code === code)

/** Debts and housing rows ask for a reason when left out; income rows do not. */
export const needsExclusionReason = (section) => section === "debts" || section === "housing"
